module.exports = __webpack_public_path__ + "static/media/unionpay.6411c5ac.png";